//// Application Packages
import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { format } from 'date-fns'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'
import {
    updateFormData,
    updateFormValidity,
    selectForms,
} from '../../reducers/formSlice'

//// Application Components

//// Carbon Components
import { RadioButton, RadioButtonGroup } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const AdditionalCriminalAndMedicaidMedicareFraudQuestionsConvictedGuiltyChapterQuestions =
    () => {
        //////// Hooks
        const dispatch = useDispatch()

        //////// State

        //////// Slices
        const settingsData = useSelector(selectSettings)
        const formsData = useSelector(selectForms)

        //// Slice Data
        const digital_name = settingsData?.['form']?.['digital_name']

        //////// Search Params

        //////// Methods

        // Re-Validate Data Submission
        const revalidation = async (event_name) => {
            // Update Validation State
            if (digital_name && event_name) {
                dispatch(
                    updateFormValidity({
                        digital_name: digital_name,
                        errors: {
                            [event_name]: false,
                            [event_name + 'ErrMsg']: '',
                        },
                    })
                )
            }
        }

        //////// Functional Methods

        // Handle Data Of All Fields + DatePicker (ID)
        const handleData = (e, id) => {
            if (e?.target?.name && e?.target?.value) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [e.target.name]: e.target.value,
                        },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.target?.name) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: { [e.target.name]: '' },
                    })
                )
                revalidation(e.target.name)
            } else if (e?.length > 0 && id) {
                dispatch(
                    updateFormData({
                        digital_name: digital_name,
                        values: {
                            [id]: format(new Date(e?.[0]), 'MM/dd/yyyy'),
                        },
                    })
                )
                revalidation(id)
            }
            //// Start Watson Assistant Journey

            //// End Watson Assistant Journey
        }

        //////// Memoization

        //////// Effects/Side Effects

        //////////////// Render & Return
        if (formsData?.[digital_name]?.values?.FELVIO === 'Y') {
            return (
                <>
                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.FELVIO1A
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.FELVIO1A
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.FELVIO1A
                        }
                        legendText="For the felonies of the first or second degree, has it been more than 15 years from the date of the plea or conviction, and completion of any sentence or subsequent period of probation?"
                        name="FELVIO1A"
                        invalid={formsData?.[digital_name]?.errors?.FELVIO1A}
                        invalidText={
                            formsData?.[digital_name]?.errors?.FELVIO1AErrMsg
                        }
                    >
                        <RadioButton
                            id="FELVIO1ATrue"
                            name="FELVIO1ATrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FELVIO1AFalse"
                            name="FELVIO1AFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FELVIO1ANotAplc"
                            name="FELVIO1ANotAplc"
                            labelText="N/A"
                            value="NA"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>

                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.FELVIO1B
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.FELVIO1B
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.FELVIO1B
                        }
                        legendText="For the felonies of the third degree, has it been more than 10 years from the date of the plea or conviction, and completion of any sentence or subsequent period of probation? (This question does not apply to felonies of the third degree under s. 893.13(6)(a), Florida Statutes)."
                        name="FELVIO1B"
                        invalid={formsData?.[digital_name]?.errors?.FELVIO1B}
                        invalidText={
                            formsData?.[digital_name]?.errors?.FELVIO1BErrMsg
                        }
                    >
                        <RadioButton
                            id="FELVIO1BTrue"
                            name="FELVIO1BTrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FELVIO1BFalse"
                            name="FELVIO1BFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FELVIO1BNotAplc"
                            name="FELVIO1BNotAplc"
                            labelText="N/A"
                            value="NA"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>

                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.FELVIO1C
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.FELVIO1C
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.FELVIO1C
                        }
                        legendText="For the felonies of the third degree under s. 893.13(6)(a), Florida Statutes, has it been more than 5 years from the date of the plea or conviction, and completion of any sentence or subsequent period of probation?"
                        name="FELVIO1C"
                        invalid={formsData?.[digital_name]?.errors?.FELVIO1C}
                        invalidText={
                            formsData?.[digital_name]?.errors?.FELVIO1CErrMsg
                        }
                    >
                        <RadioButton
                            id="FELVIO1CTrue"
                            name="FELVIO1CTrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FELVIO1CFalse"
                            name="FELVIO1CFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FELVIO1CNotAplc"
                            name="FELVIO1CNotAplc"
                            labelText="N/A"
                            value="NA"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>

                    <RadioButtonGroup
                        className={
                            formsData?.[digital_name]?.errors?.FELVIO1D
                                ? 'required invalid'
                                : 'required'
                        }
                        defaultSelected={
                            formsData?.[digital_name]?.values?.FELVIO1D
                        }
                        valueSelected={
                            formsData?.[digital_name]?.values?.FELVIO1D
                        }
                        legendText="Have you successfully completed a drug court program that resulted in the plea for the felony offense being withdrawn or the charges dismissed?"
                        name="FELVIO1D"
                        invalid={formsData?.[digital_name]?.errors?.FELVIO1D}
                        invalidText={
                            formsData?.[digital_name]?.errors?.FELVIO1DErrMsg
                        }
                    >
                        <RadioButton
                            id="FELVIO1DTrue"
                            name="FELVIO1DTrue"
                            labelText="Yes"
                            value="Y"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FELVIO1DFalse"
                            name="FELVIO1DFalse"
                            labelText="No"
                            value="N"
                            type="radio"
                            onClick={handleData}
                        />
                        <RadioButton
                            id="FELVIO1DNotAplc"
                            name="FELVIO1DNotAplc"
                            labelText="N/A"
                            value="NA"
                            type="radio"
                            onClick={handleData}
                        />
                    </RadioButtonGroup>
                </>
            )
        }
    }

export default AdditionalCriminalAndMedicaidMedicareFraudQuestionsConvictedGuiltyChapterQuestions
